import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import backgroundImage from '../../assets/images/1.jpg_large';
import './KPCardSmartParking.css';

const SmartParkingSection = styled.section`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(${backgroundImage}) center center/cover no-repeat;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    min-height: 40vh;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
`;

const RedBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: #8B0000;
  z-index: 2;
`;

const ContentContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  text-align: center;
  z-index: 3;
  position: relative;
`;

const MainTitle = styled(motion.h1)`
  font-size: 4rem;
  font-weight: 700;
  color: white;
  line-height: 1.2;
  margin-bottom: 0.5rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Subtitle = styled(motion.h2)`
  font-size: 3rem;
  font-weight: 600;
  color: white;
  line-height: 1.2;
  margin-bottom: 0.5rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const CompanyName = styled(motion.h3)`
  font-size: 2.5rem;
  font-weight: 600;
  color: white;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const KPCardSmartParking = () => {
  return (
    <SmartParkingSection>
      <Overlay />
      <RedBar />
      
      <ContentContainer>
        <MainTitle
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Smart Parking
        </MainTitle>
        
        <Subtitle
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          in Windhoek
        </Subtitle>
        
        <CompanyName
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          with KeyPlot Investments
        </CompanyName>
      </ContentContainer>
    </SmartParkingSection>
  );
};

export default KPCardSmartParking; 